import React from "react";
import SbuxRadioGroup from "../../../../../../components/SbuxRadioGroup";
import { Box, FormControlLabel, Radio } from "@mui/material";
import SbuxTranslate from "../../../../../../components/SbuxTranslate";

interface TemporaryMsgTimeOptionProps {
  name: string;
  timeOption: string;
  handleTimeOptionValueChange: (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => void;
}

const TemporaryMsgTimeOption = ({
  name,
  timeOption,
  handleTimeOptionValueChange,
}: TemporaryMsgTimeOptionProps) => {
  return (
    <SbuxRadioGroup
      value={timeOption}
      handleRadioButtonChange={handleTimeOptionValueChange}
    >
      <Box sx={{ display: "flex" }}>
        <Box sx={{ flex: 1 }}>
          <FormControlLabel
            value={"immediately"}
            control={<Radio size="small" sx={{ padding: "4px" }} />}
            label={
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    flex: 1,
                    pointerEvents:
                      timeOption !== "immediately" ? "none" : undefined,
                    opacity: timeOption !== "immediately" ? 0.6 : undefined,
                  }}
                />
                <Box
                  sx={{
                    fontSize: 13,
                    marginTop: 0.5,
                    flex: 1,
                    marginRight: 1,
                    minWidth: 100,
                  }}
                >
                  <SbuxTranslate>
                    {name === "Start Time" ? "Immediately" : "No end date"}
                  </SbuxTranslate>
                </Box>
              </Box>
            }
          />
        </Box>
        <Box sx={{ flex: 2 }}>
          <FormControlLabel
            value={"userDefined"}
            control={<Radio size="small" sx={{ padding: "4px" }} />}
            label={
              <Box
                sx={{
                  display: "flex",
                  fontSize: 13,
                  flex: 1,
                  pointerEvents:
                    timeOption !== "userDefined" ? "none" : undefined,
                  opacity: timeOption !== "userDefined" ? 0.6 : undefined,
                }}
              >
                <Box
                  sx={{
                    fontSize: 13,
                    marginTop: 0.5,
                    flex: 1,
                    marginRight: 1,
                  }}
                >
                  <SbuxTranslate>{"User Defined"}</SbuxTranslate>
                </Box>
              </Box>
            }
          />
        </Box>
      </Box>
    </SbuxRadioGroup>
  );
};

export default TemporaryMsgTimeOption;
